<template>

    <div>

        <toolbar :title="'Steuersätze bearbeiten'"></toolbar>

          <v-divider></v-divider>

            <v-responsive>
                <v-card-text >

                    <v-container class="pa-0">
                        <v-layout>
                            <v-flex xs12>

                                <v-alert
                                        v-if="googleConnected===false"
                                        type="warning"
                                         color="orange"
                                         icon="icon-info_outline"
                                         outline
                                    :value="true">
                                    Änderungen werden nicht dauerhaft gespeichert, da Sie nicht angemeldet sind.
                                </v-alert>

                                <v-list>
                                  <v-list-tile
                                    v-for="item in steuersaetze"
                                    :key="item.id"
                                  >
                                    <v-list-tile-content>
                                      <v-list-tile-title>{{ item.val }} %</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>


                                        <v-menu top left transition="slide-y-transition">
                                            <v-btn
                                                slot="activator"
                                                icon
                                            >
                                              <v-icon class="icon-more_vert"></v-icon>
                                            </v-btn>

                                            <v-list>
                                                <v-list-tile @click="removeSteuersatz(item.id)">
                                                    <v-list-tile-title><v-icon class="mr-2 icon-delete_forever"></v-icon>Entfernen</v-list-tile-title>
                                                </v-list-tile>

                                            </v-list>
                                        </v-menu>

                                    </v-list-tile-action>

                                  </v-list-tile>

                                </v-list>

                                <v-layout row justify-space-between>
                                    <v-flex xs9>
                                            <v-text-field
                                                class="ma-0 pa-0 ml-1"
                                                type="number"
                                                v-model="steuersatzNeu"
                                                max-length="3"
                                                box
                                                label="Neuer Steuersatz"
                                                suffix="%"
                                                :error="steuersatzNeuError"
                                                @keydown="steuersatzNeuError=false"
                                                @keypress.enter="addSteuersatz"
                                            >
                                            </v-text-field>
                                      </v-flex>

                                    <v-flex xs3 class="text-xs-right">
                                        <v-btn
                                              fab
                                              small
                                              :disabled="steuersatzNeu.length === 0"
                                              @click="addSteuersatz"
                                              color="green"
                                        >
                                            <v-icon class="white--text icon-add"></v-icon>
                                        </v-btn>
                                    </v-flex>

                                </v-layout>


                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-card-text>

            </v-responsive>
    </div>

</template>

<script>
    import {Utils} from "../../classes/Utils";

    export default {
        name: 'steuersaetze',
        props: {

        },
        data: () => ({
            steuersatzNeu: '',
            steuersatzNeuError: false,
        }),
        computed: {

            googleConnected() {
                return this.$store.getters.gIsLoggedIn
            },

            gToken: {
                get() {
                    return this.$store.getters.gToken
                },
            },

            /*steuersatz: {
                get() {
                    return this.$store.getters.steuersatz;
                },
                set(val) {
                    this.$store.dispatch("steuersatz", val);
                }
            },*/
            steuersaetze: {
                get() {
                    return this.$store.getters.steuersaetze
                }
            }
        },
        watch: {

        },
        methods: {

            addSteuersatz: function(){

                if ( Utils.isNullOrEmpty(this.steuersatzNeu) === false ) {

                    if ( this.steuersatzNeu > 99 ) {
                        this.$EventBus.$emit("showSnackbar", { text: 'Steuersatz ist ungültig.', status: 'warning' });
                        this.steuersatzNeuError = true;
                    }
                    else {
                        //this.steuersatze.push({id: 3, val: this.steuersatzNeu});
                        this.$store.dispatch("steuersatzAdd", this.steuersatzNeu)
                            .then( (response) => {

                                if ( response === true ) {
                                    this.steuersatzNeu = '';
                                    this.$EventBus.$emit("showSnackbar", { text: 'Steuersatz wurde hinzugefügt.', status: 'success' });
                                }
                                else {
                                    this.steuersatzNeuError = true;
                                    this.$EventBus.$emit("showSnackbar", { text: 'Steuersatz bereits vorhanden.', status: 'warning' });
                                }
                            });
                    }

                }
                else {
                    this.steuersatzNeuError = true;
                }
            },

            removeSteuersatz: function(id) {
                this.$store.dispatch("steuersatzRemove", id);

                if (this.steuersaetze.length === 0) {
                    this.$store.dispatch("steuersatzAdd", 19);
                    this.$store.dispatch("steuersatzAdd", 7);

                    this.$EventBus.$emit("showSnackbar", { text: 'Standardsätze wurden wiederhergestellt.', color: 'info' });
                }
                else {
                    this.$EventBus.$emit("showSnackbar", { text: 'Steuersatz wurde entfernt.', color: 'success' });
                }

                this.$store.dispatch("refreshCurrentSelection");
            }
        }
    }
</script>

<style scoped>

</style>
